"use client"
import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../../components/common/Footer';

export default function InstallationWorksCranePage() {
  const [isHeroVisible, setIsHeroVisible] = useState(false);
  const heroRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsHeroVisible(true);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    return () => {
      if (heroRef.current) {
        observer.unobserve(heroRef.current);
      }
    };
  }, []);

  const fadeInUp = {
    opacity: isHeroVisible ? 1 : 0,
    transform: isHeroVisible ? 'translateY(0px)' : 'translateY(30px)',
    transition: 'all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  };

  const slideInLeft = {
    opacity: isHeroVisible ? 1 : 0,
    transform: isHeroVisible ? 'translateX(0px)' : 'translateX(-40px)',
    transition: 'all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  };

  return (
    <main style={{ margin: 0, padding: 0, width: "100vw", minHeight: "100vh" }}>
      <section ref={heroRef} style={{
        background: "#000",
        padding: "100px 24px 80px 24px",
        position: "relative",
        overflow: "hidden",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}>
        <div 
          style={{
            position: "absolute",
            left: "50%",
            top: "0px",
            transform: "translateX(-50%)",
            width: "900px",
            height: "200px",
            background: "radial-gradient(50% 50% at 50% 50%,rgb(221, 3, 3) 60%, rgba(217, 13, 52, 0) 100%)",
            filter: "blur(150px)",
            zIndex: 1,
            opacity: 0.6,
          }}
        />

        <div style={{
          maxWidth: "1600px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "60px",
          alignItems: "center",
          position: "relative",
          zIndex: 10,
          width: "100%",
        }}>
          <div style={{ 
            position: "relative", 
            zIndex: 100, 
            paddingRight: "20px",
            ...slideInLeft,
            transitionDelay: "0.2s",
          }}>
            <h1 style={{
              fontSize: "42px",
              fontWeight: 600,
              color: "#fff",
              lineHeight: 1.1,
              marginBottom: "28px",
              letterSpacing: "-0.02em",
              ...fadeInUp,
              transitionDelay: "0.4s",
            }}>
              Installation Works with Crane – Complete Assembly Services
            </h1>
            
            <h2 style={{
              fontSize: "22px",
              fontWeight: 400,
              color: "#fff",
              marginBottom: "36px",
              lineHeight: 1.3,
              position: "relative",
              paddingLeft: "24px",
              ...fadeInUp,
              transitionDelay: "0.6s",
            }}>
              <span style={{
                position: "absolute",
                left: "0",
                top: "0",
                bottom: "0",
                width: "3px",
                background: "#F20C2C",
                borderRadius: "2px",
              }}></span>
              Professional Installation and Assembly Solutions
            </h2>
            
            <div style={{
              fontSize: "16px",
              color: "rgba(255,255,255,0.85)",
              lineHeight: 1.6,
              ...fadeInUp,
              transitionDelay: "0.8s",
            }}>
              <p style={{ marginBottom: "24px" }}>
                Beyond transport, we provide complete installation services using our crane 
                equipment. Our skilled technicians handle the assembly and installation of 
                structures, equipment, and components that require precision positioning and 
                professional expertise. We ensure everything is properly installed and secured.
              </p>
              
              <p>
                From HVAC systems to signage installation, our crane-assisted installation 
                services provide safe and efficient solutions for elevated and complex assemblies.
              </p>
            </div>
          </div>

          <div style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 100,
            width: "100%",
            height: "400px",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "20px",
            border: "1px solid rgba(255,255,255,0.1)",
          }}>
            <div style={{
              fontSize: "18px",
              color: "rgba(255,255,255,0.6)",
              textAlign: "center",
            }}>
              [Crane Installation Work in Progress]
            </div>
          </div>
        </div>
      </section>

      <section style={{
        background: "#111",
        padding: "80px 24px",
        textAlign: "center",
      }}>
        <div style={{
          maxWidth: "1200px",
          margin: "0 auto",
          color: "#fff",
        }}>
          <h2 style={{
            fontSize: "36px",
            fontWeight: 600,
            marginBottom: "20px",
          }}>
            Installation Services
          </h2>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "30px",
            marginTop: "40px",
          }}>
            {["HVAC Systems", "Structural Assembly", "Signage Installation", "Equipment Mounting"].map((service, index) => (
              <div key={index} style={{
                background: "rgba(255,255,255,0.05)",
                padding: "30px",
                borderRadius: "15px",
                border: "1px solid rgba(255,255,255,0.1)",
              }}>
                <h3 style={{ fontSize: "20px", marginBottom: "15px", color: "#fff" }}>
                  {service}
                </h3>
                <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px" }}>
                  Professional {service.toLowerCase()} with crane-assisted precision installation.
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
} 